import { formatDateTime } from './format'

/** Largest unit first — the first threshold an age clears is the one used. */
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 365 * 24 * 60 * 60 * 1000],
  ['month', 30 * 24 * 60 * 60 * 1000],
  ['week', 7 * 24 * 60 * 60 * 1000],
  ['day', 24 * 60 * 60 * 1000],
  ['hour', 60 * 60 * 1000],
  ['minute', 60 * 1000],
]

/**
 * How long ago an instant was, in words — "3 hours ago", "2 days ago".
 *
 * `locale` should be the active i18next language, so the phrasing follows the
 * language the rest of the page is in. Anything under a minute old, and
 * anything in the future, comes back as "now" in the locale's own words.
 */
export function formatRelativeTime(iso: string, locale: string, now = Date.now()): string {
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return ''

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  const elapsed = now - then

  for (const [unit, ms] of UNITS) {
    if (elapsed >= ms) return rtf.format(-Math.floor(elapsed / ms), unit)
  }
  return rtf.format(0, 'second')
}

/**
 * An instant in full, for the tooltip behind a relative time. Spelled in the
 * user's locale rather than the page language: a date is a date whichever
 * language the words around it are in.
 */
export function formatAbsoluteTime(iso: string): string {
  return formatDateTime(iso)
}
